export const OPEN_LOGIN_DRAWER = "OPEN_LOGIN_DRAWER";
export const CLOSE_LOGIN_DRAWER = "CLOSE_LOGIN_DRAWER";
export const OPEN_SHOPPING_CHART_DRAWER = "OPEN_SHOPPING_CHART_DRAWER";
